// Donnees du site BATI SELECT TP
// Regle : tout ce qui figure ici doit etre verifiable. Les caracteristiques machine
// proviennent des plaques signaletiques photographiees et des brochures constructeur.

export const ENTREPRISE = {
  nom: 'BATI SELECT TP',
  baseline: "Location d'engins de chantier en Île-de-France",
  adresse: '2 boulevard Carnot',
  codePostal: '94140',
  ville: 'Alfortville',
  telephone: '06 01 24 47 24',
  telephoneLien: 'tel:+33601244724',
  email: 'contact@bati-select.fr',
  emailLien: 'mailto:contact@bati-select.fr',
  horaires: 'Du lundi au vendredi, 8h à 17h',
  horairesCourts: 'Lun. au ven. 8h - 17h',
  zone: "Paris et toute l'Île-de-France",
  site: 'https://www.bati-select.fr',
};

// Informations legales, extraites de l'extrait Kbis du greffe du tribunal
// de commerce de Creteil, a jour au 25 mars 2026.
export const LEGAL = {
  denomination: 'BATI SELECT TP',
  formeJuridique: "Société à responsabilité limitée à associé unique (EURL)",
  capital: '215 000 euros',
  siren: '977 737 576',
  rcs: 'RCS Créteil 977 737 576',
  numeroGestion: '2026 B 00988',
  euid: 'FR9401.977737576',
  tva: 'FR58 977737576',
  tvaAVerifier: true,
  gerant: 'Antonio Felisberto Garcia Sousa',
  directeurPublication: 'Antonio Felisberto Garcia Sousa',
  greffe: 'Greffe du tribunal de commerce de Créteil',
  immatriculation: '2 février 2026, immatriculation d\'origine du 18 juillet 2023',
  debutActivite: '3 avril 2023',
  activites:
    "Location, achat et vente de machines de travaux publics, d'engins de levage et de terrassement et de tractopelles, vente d'accessoires hydrauliques et pneumatiques, intervention et dépannage sur site, achat et vente de matériel roulant pour les entreprises du TP, travaux de terrassement.",
};

// Les cinq gages de confiance, tous confirmes par le client
export const REASSURANCE = [
  { titre: 'Livraison sur chantier', detail: 'Sous 24 à 48 h partout en Île-de-France' },
  { titre: 'Matériel assuré', detail: 'Machines couvertes et révisées entre chaque location' },
  { titre: 'Réponse en quelques heures', detail: 'Votre devis part le jour même' },
  { titre: 'Avec ou sans chauffeur', detail: 'Vous choisissez selon vos équipes' },
  { titre: 'Une équipe de 9', detail: "Des professionnels du TP, pas un standard téléphonique" },
];

export const CHIFFRES = [
  { valeur: 18, suffixe: '', prefixe: '', libelle: 'machines au parc, entretenues et assurées' },
  { valeur: 9, suffixe: '', prefixe: '', libelle: "personnes dans l'équipe, à votre service" },
  { valeur: 60, suffixe: '', prefixe: '', libelle: 'chantiers accompagnés en Île-de-France' },
  { valeur: 48, suffixe: ' h', prefixe: '24 à ', libelle: 'pour recevoir votre machine sur le chantier' },
];

export const ETAPES = [
  {
    num: '01',
    titre: 'Vous décrivez le chantier',
    texte:
      "Le type de travaux, les dates, l'adresse et surtout la largeur de votre accès. Par téléphone ou par le formulaire, en deux minutes.",
  },
  {
    num: '02',
    titre: 'On vous répond dans la journée',
    texte:
      "On vous dit quelle machine passe chez vous, avec ou sans chauffeur, et vous recevez votre devis en quelques heures.",
  },
  {
    num: '03',
    titre: 'On livre sur votre chantier',
    texte:
      "Sous 24 à 48 h, machine propre, pleine, avec ses documents. On la décharge et on vous la remet en main propre.",
  },
  {
    num: '04',
    titre: 'Vous travaillez, on reste joignable',
    texte:
      "Un souci pendant la location, on intervient dans la journée. En fin de location, on vient récupérer la machine.",
  },
];

export const MACHINES = [
  {
    slug: 'volvo-ecr25d',
    leLa: 'la',
    nomTexte: 'Volvo ECR25D',
    visuel: '/images/machine-volvo-ecr25d.webp',
    famille: 'pelles',
    nom: 'Volvo ECR25D',
    type: 'Mini-pelle 2,5 tonnes à rayon court',
    accroche:
      "La machine des accès étroits. 1,50 m de largeur, aucun débord arrière ou presque : elle travaille le long d'un mur sans que la tourelle tape.",
    image: '/images/ecr25d-profil.jpg',
    galerie: ['/images/ecr25d-face.jpg', '/images/ecr25d-chargee.jpg', '/images/ecr25d-cabine.jpg', '/images/ecr25d-contrejour.jpg'],
    pour: ['Tranchées et réseaux', 'Fondations de maison', 'Terrassement en fond de parcelle', 'Aménagement extérieur'],
    specs: [
      ['Poids en ordre de marche', '2 490 kg (version cabine)'],
      ['Largeur hors-tout', '1 500 mm (chenilles caoutchouc 250 mm)'],
      ['Hauteur de transport', '2 535 mm'],
      ['Profondeur de fouille', '2 672 mm (balancier court)'],
      ['Portée au sol', '4 313 mm'],
      ['Hauteur de déversement', '2 784 mm'],
      ['Moteur', 'Volvo D1.1A, 3 cylindres, 15,6 kW (21 ch)'],
      ['Force de cavage au godet', '22,3 kN'],
      ['Pression au sol', '30,5 kPa'],
      ['Rayon de déport arrière', '750 mm'],
      ['Godet standard', '0,074 m³'],
      ['CACES requis', 'R482 / R482A catégorie A'],
    ],
    source: 'Brochure constructeur Volvo Construction Equipment, ECR25D Stage V.',
  },
  {
    slug: 'sunward-swe25uf',
    leLa: 'la',
    nomTexte: 'Sunward SWE25UF',
    visuel: '/images/machine-sunward-swe.webp',
    famille: 'pelles',
    nom: 'Sunward SWE25UF',
    type: 'Mini-pelle 2,75 tonnes à rayon ultra-court',
    accroche:
      "Machine de 2025, équipée pour le tri et la démolition légère. Le rayon ultra-court passe là où une pelle classique ne peut pas pivoter.",
    image: '/images/swe25uf-remorque.jpg',
    galerie: ['/images/swe25uf-cabine.jpg', '/images/swe25uf-plaque.jpg', '/images/acc-pince-de-tri.jpg'],
    pour: ['Démolition légère', 'Tri et évacuation', 'Chantiers urbains encaissés', 'Rénovation en site occupé'],
    specs: [
      ['Poids en ordre de marche', '2 750 kg'],
      ['Puissance moteur', '15,4 kW à 2 400 tr/min'],
      ['Année de fabrication', '2025'],
      ['Type', 'Pelle hydraulique sur chenilles, rayon ultra-court'],
      ['Équipements disponibles', 'Brise-roche hydraulique, pince de tri, godet de curage'],
      ['Attache', 'Attache rapide'],
      ['CACES requis', 'R482 / R482A catégorie A'],
    ],
    source: 'Plaque signalétique constructeur Sunward Intelligent Equipment, machine 2025.',
  },
  {
    slug: 'volvo-ecr50d',
    leLa: 'la',
    nomTexte: 'Volvo ECR50D',
    visuel: '/images/machine-volvo-ecr50d.webp',
    famille: 'pelles',
    nom: 'Volvo ECR50D',
    type: 'Mini-pelle 5 tonnes à rayon court',
    accroche:
      "Quand la 2,5 tonnes ne suffit plus. Près de 3,70 m de profondeur de fouille et 36 kN au godet, sans jamais déborder derrière les chenilles.",
    image: '/images/ecr50d-operateur.jpg',
    galerie: ['/images/ecr50d-arriere.jpg', '/images/ecr50d-remorque.jpg', '/images/ecr50d-tableau.jpg', '/images/acc-godet-curage.jpg'],
    pour: ['Terrassement de maison', 'Assainissement', 'VRD et voirie', 'Enrochement léger'],
    specs: [
      ['Poids en ordre de marche', '5 010 kg'],
      ['Largeur hors-tout', '1 920 mm (chenilles caoutchouc 400 mm)'],
      ['Hauteur de transport', '2 570 mm'],
      ['Profondeur de fouille', '3 659 mm (balancier court)'],
      ['Portée au sol', '5 771 mm'],
      ['Hauteur de déversement', '3 809 mm'],
      ['Moteur', 'Volvo D2.6A, 4 cylindres, 31,2 kW (42 ch)'],
      ['Force de cavage au godet', '36,1 kN'],
      ['Pression au sol', '28,4 kPa'],
      ['Rayon de déport arrière', '960 mm, soit aucun débord derrière les chenilles'],
      ['Godet standard', '0,144 m³'],
      ['CACES requis', 'R482 / R482A catégorie A'],
    ],
    source: 'Brochure constructeur Volvo Construction Equipment, ECR50D.',
  },
  {
    slug: 'jcb-525-60',
    leLa: 'le',
    nomTexte: 'JCB 525-60',
    visuel: '/images/machine-jcb-525-60.webp',
    famille: 'manutention',
    nom: 'JCB 525-60 Telescopic',
    type: 'Chariot élévateur télescopique 2,5 tonnes',
    accroche:
      "Machine de 2025, compacte pour un télescopique : 1,84 m de large, elle passe dans un portail et lève 2,5 tonnes à 6 mètres.",
    image: '/images/jcb525-profil.jpg',
    galerie: ['/images/jcb525-fourches.jpg', '/images/jcb525-parc.jpg', '/images/jcb525-cabine.jpg', '/images/jcb525-plaque.jpg'],
    pour: ['Approvisionnement de chantier', 'Manutention en entrepôt', 'Levage de charges en hauteur', 'Logistique industrielle'],
    specs: [
      ['Capacité nominale', '2 500 kg'],
      ['Hauteur de levage', '6 m'],
      ['Portée maximale', '3,5 m'],
      ['Capacité à portée maximale', '750 kg'],
      ['Largeur standard', '1,84 m'],
      ['Hauteur standard', '1,89 m'],
      ['Longueur au tablier', '4 m'],
      ['Poids en ordre de marche', '5 490 kg'],
      ['Moteur', 'JCB Diesel by Kohler Stage V, 4 cylindres 2,5 L, 55 kW (75 ch)'],
      ['Transmission', 'Hydrostatique à variation continue, 20 km/h'],
      ['Direction', '3 modes : 2 roues, 4 roues et crabe'],
      ['Année de fabrication', '2025'],
      ['CACES requis', 'R482 / R482A catégorie F (chariot de chantier)'],
    ],
    source: 'Fiche caractéristiques constructeur JCB, machine 2025.',
  },

  // Les trois machines ci-dessous ont ete ajoutees au parc en aout 2026.
  // Les caracteristiques proviennent des fiches techniques constructeur citees
  // dans le champ "source". Comme pour les autres machines, la plaque
  // signaletique de l'engin livre fait foi.
  {
    slug: 'chariot-elevateur',
    leLa: 'le',
    nomTexte: 'chariot élévateur',
    visuel: '/images/machine-chariot-elevateur.webp',
    famille: 'manutention',
    nom: 'Chariot élévateur HELI 2,5 t',
    type: 'Chariot frontal GPL, 2,5 tonnes',
    accroche:
      "Pour décharger un camion, déplacer des palettes et approvisionner un atelier. Au gaz, il travaille en intérieur ventilé comme en extérieur, sans les fumées d'un diesel.",
    pour: [
      'Déchargement de camions et de semi-remorques',
      'Manutention de palettes en entrepôt',
      "Approvisionnement d'atelier et de ligne de production",
      'Stockage et reprise sur parc',
    ],
    aDire: [
      'La charge la plus lourde à lever, en kilos',
      'La hauteur de levée dont vous avez besoin',
      'Intérieur ou extérieur, et la nature du sol',
      'La largeur de vos allées de circulation',
    ],
    specs: [
      ['Capacité nominale', '2 500 kg à 500 mm du centre de charge'],
      ['Hauteur de levée standard', '3 000 mm (mât duplex M300)'],
      ['Hauteur mât replié', '2 000 mm'],
      ['Hauteur mât déployé', '4 030 mm avec dosseret'],
      ['Hauteur hors-tout arceau', '2 150 mm'],
      ['Largeur hors-tout', '1 150 mm'],
      ['Longueur hors-tout', '2 638 mm sans les fourches, 3 708 mm avec'],
      ['Rayon de braquage extérieur', '2 240 mm'],
      ['Poids en service', '3 740 kg'],
      ['Moteur', 'Kubota WG2503, 4 cylindres, 2 491 cm³, 43,5 kW (59 ch) au GPL'],
      ['Norme antipollution', 'Euro Stage V'],
      ['Vitesse en charge', '17 km/h'],
      ['Vitesse de levée en charge', '535 mm/s'],
      ['Pente franchissable en charge', '29 %'],
      ['Pneumatiques', 'Gonflés, 7.00-12 à l\'avant, 6.00-9 à l\'arrière'],
      ['CACES requis', 'R489 catégorie 3'],
    ],
    caces: "R489 catégorie 3, chariot élévateur frontal en porte-à-faux jusqu'à 6 tonnes.",
    source:
      "Brochure constructeur Anhui HELI, série H3 thermique 1 à 3,5 t Euro Stage V, référence CP(Q)YD25. La référence exacte et la capacité résiduelle réelle avec le tablier installé sont à lire sur la plaque de charge de la machine.",
  },
  {
    slug: 'nacelle-elevatrice',
    leLa: 'la',
    nomTexte: 'nacelle élévatrice',
    visuel: '/images/machine-nacelle.webp',
    famille: 'elevation',
    nom: 'JCB S2632E',
    type: 'Nacelle à ciseaux électrique, 9,92 m',
    accroche:
      "Elle passe une porte standard avec ses 83 cm de large, et monte à près de 10 mètres. Cent pour cent électrique, sans bruit ni émission : c'est la machine des chantiers en site occupé.",
    pour: [
      'Travaux en façade intérieure et en bardage',
      'Pose de réseaux, de gaines et de luminaires en hauteur',
      'Maintenance en entrepôt et en atelier',
      'Peinture et second œuvre en grande hauteur',
    ],
    aDire: [
      'La hauteur de travail à atteindre',
      'Le nombre de personnes et le matériel à embarquer',
      'La largeur du passage pour amener la machine',
      'La nature et la planéité du sol',
    ],
    specs: [
      ['Hauteur de travail', '9,92 m'],
      ['Hauteur de plancher', '7,92 m'],
      ['Capacité de la plateforme', '250 kg, 2 personnes'],
      ['Largeur hors-tout', '0,83 m, passage de porte standard'],
      ['Longueur repliée', '2,39 m'],
      ['Hauteur repliée', '1,96 m garde-corps rabattus, 2,33 m déployés'],
      ['Plateforme', '2,25 m par 0,81 m, extension de 0,90 m'],
      ['Poids', '2 187 kg'],
      ['Alimentation', '24 V, quatre batteries 6 V de 225 Ah'],
      ['Rayon de braquage', '2,10 m extérieur, nul à l\'intérieur'],
      ['Pente franchissable', '25 %'],
      ['Roues', 'Bandages pleins non marquants, 380 par 133 mm'],
      ['Usage', 'Intérieur'],
      ['CACES requis', 'R486 catégorie A'],
    ],
    caces: "R486 catégorie A, plateforme à élévation verticale de type 3.",
    source:
      'Fiche technique constructeur JCB 32492 en-GB 02/25 édition 2, et brochure française JCB 31176 fr-FR édition 6, version à entraînement électrique.',
  },
  {
    slug: 'compresseur-chantier',
    leLa: 'le',
    nomTexte: 'compresseur',
    visuel: '/images/machine-compresseur.webp',
    visuelHauteurMax: '300px',
    famille: 'energie',
    nom: 'Kaeser Mobilair M 59',
    type: 'Compresseur de chantier sur remorque, 5,5 m³/min',
    accroche:
      "L'air comprimé qui alimente vos brise-béton, aiguilles vibrantes et outils pneumatiques, partout où il n'y a ni prise ni groupe. Trois marteaux de chantier en simultané.",
    pour: [
      'Alimentation de marteaux et brise-béton pneumatiques',
      'Travaux de démolition et de reprise en sous-œuvre',
      'Sablage, aérogommage et nettoyage de surfaces',
      'Chantiers sans alimentation électrique',
    ],
    aDire: [
      'Les outils à alimenter et leur nombre',
      "Le débit d'air nécessaire, si vous le connaissez",
      "La durée d'utilisation par jour",
      'Le véhicule qui tractera la remorque',
    ],
    specs: [
      ['Débit à 7 bar', '5,5 m³/min, soit 5 500 l/min'],
      ['Débit à 10 bar', '4,7 m³/min'],
      ['Pression de service', 'Version 10 bar ou 14 bar, réglable par pas de 0,1 bar'],
      ['Moteur', 'Hatz 3H50TICD, 3 cylindres turbo, 43,5 kW (59 ch)'],
      ['Norme antipollution', 'UE phase V, filtre à particules de série'],
      ['Carburant', 'Gazole, HVO 100 admis'],
      ['Réservoir', '60 l en version légère, 80 l en version PE'],
      ['Poids en ordre de marche', '740 kg en version légère, 900 kg en version PE freinée'],
      ['Dimensions', '2 980 à 3 420 mm de long, 1 480 mm de large, 1 370 mm de haut'],
      ['Sorties air', 'Deux en G 3/4 pouce et une en G 1 pouce'],
      ['Niveau sonore', '69 dB(A) à 10 mètres'],
      ['Température de service', 'De -10 à +45 °C'],
      ['Châssis', 'Remorque à timon réglable, non freinée ou freinée à inertie'],
    ],
    caces:
      "Pas de CACES pour le compresseur. Le permis de tracter dépend du poids total autorisé en charge porté sur la carte grise de la remorque et de celui de votre véhicule.",
    source:
      'Brochure constructeur Kaeser, MOBILAIR M 59 et M 65, référence P-559FR édition 3/25.',
  },
];

// Libelles des familles, utilises pour les titres de sections et les filtres.
export const FAMILLES = {
  pelles: 'Mini-pelles',
  manutention: 'Manutention et levage',
  elevation: 'Travail en hauteur',
  energie: 'Air comprimé',
};

export const ACCESSOIRES = [
  { nom: 'Brise-roche hydraulique', detail: 'Démolition, béton armé et roche', image: '/images/acc-brh.webp', detoure: true },
  { nom: 'Pince de tri', detail: 'Tri et évacuation de gravats sur chantier', image: '/images/acc-pince.webp', detoure: true },
  { nom: 'Godet de terrassement', detail: 'Plusieurs largeurs selon la fouille', image: '/images/acc-godet-renfoncement.webp', detoure: true },
  { nom: 'Godet de curage', detail: 'Reprise de fond, talutage et nettoyage', image: '/images/acc-godet-curage-2.webp', detoure: true },
];

export const SECTEURS = [
  {
    titre: 'Terrassement et VRD',
    texte: "Tranchées, fouilles, réseaux, plateformes. Les machines à rayon court passent là où les autres bloquent.",
  },
  {
    titre: 'Maçonnerie et gros œuvre',
    texte: "Fondations, sous-œuvre, approvisionnement. Le télescopique monte vos charges pendant que la pelle creuse.",
  },
  {
    titre: 'Démolition et curage',
    texte: "Brise-roche et pince de tri disponibles sur nos pelles, pour la démolition légère et le tri sur place.",
  },
  {
    titre: 'Industrie et logistique',
    texte: "Manutention lourde, déchargement, reprise de stock. Le JCB 525-60 lève 2,5 tonnes jusqu'à 6 mètres.",
  },
  {
    titre: 'Aménagement extérieur',
    texte: "Terrasses, allées, piscines, murs de soutènement. La 2,5 tonnes rentre par un portail de 1,60 m.",
  },
  {
    titre: 'Entreprises générales',
    texte: "Un renfort de parc ponctuel, sans immobiliser votre trésorerie ni votre porte-engins.",
  },
];

export const COMMUNES_PAGES = [
  {
    slug: 'creteil',
    nom: 'Créteil',
    cp: '94000',
    intro:
      "Créteil est à dix minutes de notre dépôt d'Alfortville. Entre les opérations de renouvellement urbain, les chantiers du Grand Paris Express et la densité de logements collectifs, les accès sont souvent étroits et les délais courts.",
    argument:
      "Nos mini-pelles à rayon court sont faites pour ça : 1,50 m de large pour la 2,5 tonnes, aucun débord arrière, donc pas de risque de taper une façade ou une clôture en pivotant.",
  },
  {
    slug: 'maisons-alfort',
    nom: 'Maisons-Alfort',
    cp: '94700',
    intro:
      "Maisons-Alfort est la commune voisine d'Alfortville, de l'autre côté de la Marne. Nos machines sont chez vous en quelques minutes de route, ce qui simplifie autant la livraison que la reprise en fin de chantier.",
    argument:
      "Beaucoup de pavillonnaire et de rénovation, donc des accès de portail à respecter au centimètre. Dites-nous la largeur, on vous dit quelle machine passe.",
  },
  {
    slug: 'ivry-sur-seine',
    nom: 'Ivry-sur-Seine',
    cp: '94200',
    intro:
      "Ivry-sur-Seine concentre des programmes de logements, des reconversions de friches industrielles et beaucoup de second œuvre. Les chantiers y sont serrés, souvent en site occupé.",
    argument:
      "Pelle à rayon ultra-court, brise-roche et pince de tri disponibles : de quoi démolir et évacuer sans encombrer la voirie ni bloquer les riverains.",
  },
  {
    slug: 'vitry-sur-seine',
    nom: 'Vitry-sur-Seine',
    cp: '94400',
    intro:
      "Vitry-sur-Seine est l'une des communes les plus actives du Val-de-Marne en construction de logements. Entre les opérations neuves et les chantiers de voirie, la demande en machines de terrassement y est constante.",
    argument:
      "Notre 5 tonnes creuse à 3,65 m et attaque à 36 kN, ce qui couvre la grande majorité des terrassements de maison et d'assainissement du secteur.",
  },
  {
    slug: 'charenton-le-pont',
    nom: 'Charenton-le-Pont',
    cp: '94220',
    intro:
      "Charenton-le-Pont est limitrophe de Paris et d'Alfortville. Circulation dense, stationnement compliqué, gabarits limités : sortir votre porte-engins pour aller chercher une machine y coûte souvent plus cher que la location elle-même.",
    argument:
      "On livre et on reprend la machine sur place. Vous ne mobilisez ni votre camion, ni votre chauffeur, ni une place de stationnement toute la journée.",
  },
  {
    slug: 'bonneuil-sur-marne',
    nom: 'Bonneuil-sur-Marne',
    cp: '94380',
    intro:
      "Bonneuil-sur-Marne accueille le port fluvial et l'une des plus grandes zones industrielles du Val-de-Marne. Les besoins y sont autant en manutention qu'en terrassement.",
    argument:
      "Le chariot télescopique JCB 525-60 lève 2,5 tonnes à 6 mètres et se déplace à 20 km/h sur site, avec trois modes de direction pour manœuvrer dans un entrepôt comme sur une plateforme.",
  },
  {
    slug: 'rungis',
    nom: 'Rungis',
    cp: '94150',
    intro:
      "Rungis et son marché d'intérêt national forment l'un des plus gros bassins de manutention d'Île-de-France. Une machine immobilisée, c'est une chaîne d'expédition qui ralentit.",
    argument:
      "Notre télescopique part sous 24 à 48 h, et si vous avez un souci pendant la location, on intervient dans la journée. Pas de ticket, pas de plateforme téléphonique : un interlocuteur direct.",
  },
  {
    slug: 'orly',
    nom: 'Orly',
    cp: '94310',
    intro:
      "Orly combine la plateforme aéroportuaire, les zones d'activités et les chantiers d'infrastructure du sud du département. Les contraintes d'accès et d'horaires y sont fortes.",
    argument:
      "On cale la livraison sur vos créneaux. Machines révisées, assurées, livrées avec leurs documents de conformité, ce qui simplifie les contrôles sur les sites réglementés.",
  },
  {
    slug: 'choisy-le-roi',
    nom: 'Choisy-le-Roi',
    cp: '94600',
    intro:
      "Choisy-le-Roi mêle habitat collectif, pavillonnaire et bord de Seine. Beaucoup de chantiers d'assainissement, de réseaux et de reprise de voirie.",
    argument:
      "Nos pelles à rayon court travaillent en bordure de chaussée sans empiéter sur la voie voisine. Un vrai gain quand la circulation doit rester ouverte.",
  },
  {
    slug: 'villeneuve-saint-georges',
    nom: 'Villeneuve-Saint-Georges',
    cp: '94190',
    intro:
      "Villeneuve-Saint-Georges est au sud du département, sur l'axe Seine. Terrassement, réseaux, rénovation de logements et travaux de voirie s'y côtoient.",
    argument:
      "Location à la journée, à la semaine ou au mois, avec ou sans chauffeur. Vous ne payez que le temps dont vous avez besoin.",
  },
];

export const COMMUNES_LISTE = [
  'Alfortville', 'Créteil', 'Maisons-Alfort', 'Charenton-le-Pont', 'Saint-Maurice',
  'Ivry-sur-Seine', 'Vitry-sur-Seine', 'Choisy-le-Roi', 'Bonneuil-sur-Marne', 'Rungis',
  'Orly', 'Villeneuve-Saint-Georges', 'Thiais', 'Valenton', 'Limeil-Brévannes',
  'Villejuif', 'Vincennes', 'Saint-Mandé', 'Joinville-le-Pont', 'Nogent-sur-Marne',
  'Champigny-sur-Marne', 'Le Kremlin-Bicêtre', 'Chevilly-Larue', 'Paris',
  'Boulogne-Billancourt', 'Montreuil', 'Saint-Denis',
];

export const FAQ = [
  {
    cat: 'La location',
    accueil: true,
    q: "Louez-vous avec ou sans chauffeur ?",
    r: "Les deux. Sans chauffeur si vous avez vos équipes et les CACES qui vont bien, avec chauffeur si vous préférez que la machine arrive avec quelqu'un qui la connaît. Vous choisissez au moment du devis.",
  },
  {
    cat: 'La location',
    accueil: true,
    q: "Peut-on louer à la journée ?",
    r: "Oui. Journée, semaine ou mois, selon votre chantier. Dites-nous vos dates, on cale le devis dessus.",
  },
  {
    cat: 'La location',
    q: "Louez-vous aux particuliers ?",
    r: "Nous travaillons avec les professionnels du bâtiment, des travaux publics et de l'industrie. C'est un choix : nos machines partent sur des chantiers encadrés, avec des conducteurs formés ou avec l'un de nos chauffeurs.",
  },
  {
    cat: 'La location',
    q: "Peut-on prolonger une location en cours ?",
    r: "Oui, sous réserve que la machine ne soit pas réservée derrière vous. Prévenez-nous dès que vous savez que le chantier glisse, c'est le meilleur moyen de garder la machine.",
  },
  {
    cat: 'La location',
    q: "Faut-il réserver longtemps à l'avance ?",
    r: "Pas nécessairement. En pratique, une machine part souvent sous 24 à 48 h. En période chargée, réserver quelques jours avant sécurise vos dates, surtout si vous avez besoin d'un accessoire précis.",
  },

  {
    cat: 'Livraison et zone',
    accueil: true,
    q: "Livrez-vous sur le chantier ?",
    r: "Oui, partout en Île-de-France, sous 24 à 48 h. On décharge la machine sur place et on vient la récupérer en fin de location. Vous n'immobilisez ni votre camion, ni votre chauffeur.",
  },
  {
    cat: 'Livraison et zone',
    accueil: true,
    q: "Quel est le délai pour obtenir une machine ?",
    r: "Vous recevez votre devis en quelques heures et la machine part généralement sous 24 à 48 h selon la disponibilité et la commune. Pour un besoin urgent, appelez plutôt que d'écrire : on vous répond tout de suite.",
  },
  {
    cat: 'Livraison et zone',
    q: "Quelles communes desservez-vous ?",
    r: "Toute l'Île-de-France, au départ de notre dépôt d'Alfortville. Nous sommes particulièrement rapides sur le Val-de-Marne et la petite couronne. Si votre commune ne figure pas sur le site, appelez-nous, elle est probablement couverte.",
  },
  {
    cat: 'Livraison et zone',
    q: "Que faut-il prévoir pour la livraison ?",
    r: "Un accès praticable pour le porte-engins et une zone de déchargement dégagée. Dites-nous la largeur du passage et la nature du sol au moment du devis, on vous dit tout de suite si ça passe et ce qu'il faut anticiper.",
  },
  {
    cat: 'Livraison et zone',
    q: "Puis-je venir chercher la machine moi-même ?",
    r: "Oui, si vous disposez d'un porte-engins adapté et des points d'arrimage nécessaires. Parlons-en au moment du devis, on vérifie ensemble le poids et le gabarit à transporter.",
  },

  {
    cat: 'Conduite et sécurité',
    accueil: true,
    q: "Faut-il un CACES pour louer une machine chez vous ?",
    r: "En location sans chauffeur, oui : le conducteur doit être formé et titulaire d'une autorisation de conduite délivrée par son employeur, conformément à l'article R4323-56 du Code du travail. Le CACES R482 catégorie A couvre nos mini-pelles, la catégorie F le chariot télescopique. Si vous n'avez pas de conducteur habilité, prenez la machine avec chauffeur : c'est fait pour ça.",
  },
  {
    cat: 'Conduite et sécurité',
    q: "Qui délivre l'autorisation de conduite ?",
    r: "L'employeur du conducteur, jamais le loueur. Elle repose sur trois éléments : une aptitude médicale, un contrôle des connaissances et du savoir-faire, et la connaissance du site où la machine va travailler. Le CACES sert à valider le deuxième point, il ne remplace pas l'autorisation.",
  },
  {
    cat: 'Conduite et sécurité',
    q: "La R482 est-elle toujours valable depuis la R482A ?",
    r: "Oui. La recommandation R482A a remplacé la R482 au 1er décembre 2025, sans effet rétroactif : les CACES en cours restent valables jusqu'à leur échéance, la durée de validité reste de dix ans. Le principal changement concerne le classement des moto-basculeurs, pas les pelles.",
  },
  {
    cat: 'Conduite et sécurité',
    q: "Quels documents accompagnent la machine ?",
    r: "Le rapport de vérification générale périodique à jour, la notice d'utilisation du constructeur et les documents de conformité. Vous les conservez pendant toute la durée de la location, ils vous sont demandés en cas de contrôle de l'inspection du travail ou de la CARSAT.",
  },
  {
    cat: 'Conduite et sécurité',
    accueil: true,
    q: "Quelle machine pour mon accès étroit ?",
    r: "Notre mini-pelle 2,5 tonnes fait 1,50 m de large et 2,54 m de haut : elle passe dans la plupart des portails. Envoyez-nous la largeur exacte de votre passage et la nature du sol, on vous dit ce qui rentre.",
  },

  {
    cat: 'Matériel, assurance et litiges',
    q: "Le matériel est-il assuré ?",
    r: "Oui, nos machines sont assurées et révisées entre chaque location. Le détail de la couverture, de la franchise et du dépôt de garantie figure sur votre devis et dans le contrat de location, avant toute signature. Pas de mauvaise surprise après coup.",
  },
  {
    cat: 'Matériel, assurance et litiges',
    q: "Qui est responsable de la machine pendant la location ?",
    r: "En location sans chauffeur, la garde du matériel vous est transférée de la livraison à la restitution. Vous en assumez la conservation et l'usage conforme. C'est la raison pour laquelle l'état des lieux est signé des deux côtés au départ comme au retour.",
  },
  {
    cat: 'Matériel, assurance et litiges',
    q: "Que se passe-t-il en cas de panne pendant la location ?",
    r: "Vous nous appelez et on intervient dans la journée. Une machine à l'arrêt sur votre chantier, c'est un problème pour vous comme pour nous.",
  },
  {
    cat: 'Matériel, assurance et litiges',
    q: "Dans quel état faut-il rendre la machine ?",
    r: "Dans l'état où vous l'avez reçue : nettoyée et le plein fait. L'état des lieux de retour est comparé à celui du départ. Ce qui a été constaté au départ ne se rediscute pas au retour, c'est justement là l'intérêt du document.",
  },

  {
    cat: 'Devis et tarifs',
    q: "Affichez-vous vos tarifs ?",
    r: "Non, et pour une bonne raison : un tarif dépend de la machine, de la durée, des accessoires, de la commune de livraison et du recours ou non à un chauffeur. Un prix affiché serait faux dans la moitié des cas. On vous envoie un devis précis en quelques heures.",
  },
  {
    cat: 'Devis et tarifs',
    q: "Le devis est-il gratuit ?",
    r: "Oui, et sans engagement. Vous nous décrivez le chantier, on vous répond avec la machine adaptée et son tarif. Si notre proposition ne vous convient pas, ça s'arrête là.",
  },
  {
    cat: 'Devis et tarifs',
    q: "Sous quel délai répondez-vous ?",
    r: "En quelques heures ouvrées. Une demande reçue le matin part dans la journée. Nos horaires sont du lundi au vendredi, de 8h à 17h.",
  },

  {
    cat: 'Le site',
    q: "À qui appartient ce site internet ?",
    r: "À BATI SELECT TP, à 100 %. Le code source et le nom de domaine sont récupérables sur simple demande, sans frais, sans délai de préavis et sans aucun blocage technique de la part de l'agence qui l'a réalisé.",
  },
  {
    cat: 'Le site',
    q: "Que faites-vous des informations envoyées par le formulaire ?",
    r: "Elles servent uniquement à établir votre devis et à assurer le suivi commercial qui en découle. Elles ne sont ni vendues ni cédées, sont conservées trois ans après notre dernier échange, et vous pouvez à tout moment demander à les consulter, les corriger ou les supprimer. Le détail figure sur notre page de politique de confidentialité.",
  },
];

// Mesure d'audience. Rien n'est charge tant que 'fournisseur' vaut null
// et tant que le visiteur n'a pas accepte la categorie "mesure d'audience".
// Valeurs possibles pour fournisseur : 'ga4', 'matomo', null.
export const ANALYTIQUE = {
  fournisseur: null,
  id: '',        // ga4 : 'G-XXXXXXXXXX'  |  matomo : identifiant du site
  hote: '',      // matomo uniquement : 'https://analytics.exemple.fr/'
};

export const NAV = [
  { to: '/nos-engins', label: 'Nos engins' },
  { to: '/location-sans-chauffeur', label: 'Sans chauffeur' },
  { to: '/livraison-ile-de-france', label: 'Livraison' },
  { to: '/entreprise', label: "L'entreprise" },
  { to: '/faq', label: 'FAQ' },
  { to: '/contact', label: 'Contact' },
];
